
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from '@/layouts/default';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useEffect, useMemo, useRef, useState } from 'react';
import Masonry from 'react-masonry-css';

import { getSeoInfo } from '@/api/growth';
import { getCategories, getCategoriesResult, GetCategoriesResultParams } from '@/api/item';
import categoryEmptyImg from '@/assets/images/weee-category-empty.png';
import CateHeader from '@/components/category/CateHeader';
import ProgressBar from '@/components/category/ProgressBar';
import YouMayLike from '@/components/category/YouMayLike';
import withPageDataCache from '@/components/common/CacheList';
import Empty from '@/components/common/Empty';
import HorizontalSlideList from '@/components/common/HorizontalSlideListV1';
import InfiniteScroll from '@/components/common/InfiniteScroll';
import ProductCard from '@/components/common/ProductCard/VerticalVideo';
import RecommendBanner from '@/components/common/RecommendBanner';
import useAutoSetWhatInfo from '@/components/common/SharePopup/hooks/set-wechat-info';
import Skeleton from '@/components/common/Skeleton';
import VendorCard from '@/components/common/VendorCard';
import { CategoryKey } from '@/constants/category';
import CONSTANT from '@/constants/const';
import { CategoryMod } from '@/constants/track';
import elementInView from '@/hooks/elementInView';
import useListFilter from '@/hooks/useListFilter';
import useCart from '@/store/shopping';
import { CategoryType, FilterType, ShowType } from '@/types/category.d';
import {
  getDeliveryDateFromCookie,
  getFirstDeliveryDate,
  getLangFromCookie,
  getZipCodeFromCookie,
  setLanguageToFrontend
} from '@/utils/business';
import {
  couldShowFtuPopup,
  couldShowFtuPopupOrganic,
  doGoogleOneTapExperiment,
  getOrganicTriggered
} from '@/utils/ftu';
import logger from '@/utils/logger';
import { getValueFromCookie, isRobot } from '@/utils/tool';

import Footer from '@/components/common/Footer';
import { defaultBack } from '@/components/common/HeaderNew';
import DynamicCreateAccount from '@/components/homepage/components/DynamicCreateAccount';
import { getLoginState } from '@/utils/common/user';
import fetchTrendingTopics from '@/utils/trending-topics';
import { getAssetsCdnConfig } from '@weee-fe/module';
import { getHttpReqAwareProps } from '@/utils/http-req-aware-helper';
import { GetServerSideProps } from 'next';
import { twMerge } from 'tailwind-merge';
import useSourceOfStudent from '@/hooks/source-of-student';
import useGlobalNavHeader from '@/hooks/globalnavheader/provider';

const DynamicCombineFreeShipping = dynamic(() => import('@/components/order/CombineFreeDeliveryDialog'), {
  ssr: false
});

interface filterItem {
  catalogue_num?: string;
  [key: string]: string;
}

const defaultOffset = 0;
const defaultLimit = 12;
const defaultFilterCategory = 'sale';

/**
 * 分类页路由
 * !!一级和二级分类改为平级，路由支持不带参数访问
 * /mkpl/category/{categoryKey}/{categorySlug?} （一级分类可不加categorySlug）
 */

export function Category(props) {
  const {
    getCache,
    updateCache,
    seoInfo,
    path,
    categories,
    productsInfo,
    isRobot,
    isLogin,
    ftuPopupTriggered,
    organicTriggered,
    relatedTopicsData
  } = props;
  const { t, lang } = useTranslation('common');
  const { updateQueryUrl } = useListFilter();
  const router = useRouter();
  const { locale, isReady } = router;
  const query = router?.query as ObjectType;
  const filterCategory = query.slug[0];

  const initCategoryItem = {
    top_img_url: undefined,
    color: undefined
  };

  const timer = useRef(null);
  const _gFiltersRef = useRef<filterItem>({});
  const _gQueryParamsRef = useRef<GetCategoriesResultParams>({
    zipcode: '',
    date: '',
    lang: '',
    filter_sub_category: ''
  });

  const [sortRadio, setSortRadio] = useState<string>();

  // 从cookie获取相关信息
  const deliveryDateInCookie = getDeliveryDateFromCookie() || getFirstDeliveryDate();
  const zipcodeInCookie = getZipCodeFromCookie();
  const [mainCategoryListArr, setMainCategoryListArr] = useState(categories || []);
  const [secondCategoryListArr, setSecondCategoryListArr] = useState(productsInfo.categories || []);
  const [mainCategory, setMainCategory] = useState<CategoryType>({
    key: productsInfo.search_catalogue_num,
    color: categories.find(item => item.key === productsInfo.search_catalogue_num)?.color
  });
  const [secondCategory, setSecondCategory] = useState({ catalogue_num: '', catalogue_name: '' });

  const [sortArr, setSortArr] = useState(productsInfo.sorts || []);
  const [filterArr, setFilterArr] = useState(productsInfo.filters || []);
  const [filterCheckBoxArr, setFilterCheckBoxArr] = useState([]);
  const [filterCount, setFilterCount] = useState<number>(0);
  const [explorerFilterData, setExplorerFilterData] = useState<any>({});
  const [productsList, setProductsList] = useState(productsInfo.products || []);
  const [loading, setLoading] = useState(false);
  const [ymlHeight, setYmlHeight] = useState<number>(null);

  const [totalCount, setTotalCount] = useState(productsInfo.filter_total_count);
  const [preCategoryItem, setPreCategoryItem] = useState(initCategoryItem);
  const [nextCategoryItem, setNextCategoryItem] = useState(initCategoryItem);
  //修改一级分类
  const [changeCategory, setChangeCategory] = useState(false);
  //修改二级分类
  const [secondLoading, setSecondLoading] = useState(false);
  const [hasMoreProduct, setHasMoreProduct] = useState(false);
  const { handleSyncTagInfo, handleSyncYouMayLike } = useCart();

  const [vendersList, setVendersList] = useState(productsInfo.venders || []);
  const [showType, setShowType] = useState(productsInfo.show_style || 'normal');
  const [showPopupCreateAccount, setShowPopupCreateAccount] = useState(false);
  const [showCombine, setShowCombine] = useState(false);

  const ftuRef = useRef(null);

  useEffect(() => {
    const hasShow = !!localStorage?.getItem(CONSTANT.COMBINE_SHIPPING_FREE);
    if (isReady && query?.combine_free_shipping === 'true' && !hasShow) {
      setShowCombine(true);
    }
  }, [isReady, query?.combine_free_shipping]);

  const isPlayIdRef = useRef('');

  const listRef = useRef<HTMLDivElement>(null);
  const cacheInfoRef = useRef<any>({
    productsList: productsList,
    mainCategory: mainCategory,
    mainCategoryListArr: mainCategoryListArr,
    secondCategory: secondCategory,
    secondCategoryListArr: secondCategoryListArr,
    query: query,
    hasMoreProduct: hasMoreProduct,
    sortArr: sortArr,
    filterArr: filterArr,
    totalCount: totalCount,
    yAxis: 0,
    zipCode: zipcodeInCookie,
    deliveryDate: deliveryDateInCookie,
    vendersList: vendersList,
    showType: showType
  });

  const isEmpty = useMemo(() => {
    return (
      (showType === ShowType.normal && productsList?.length === 0) ||
      (showType === ShowType.vender && vendersList?.length === 0) ||
      (showType === ShowType.group && secondCategoryListArr?.length === 0)
    );
  }, [showType, vendersList, productsList, secondCategoryListArr]);

  const isLoading = useMemo(() => {
    return changeCategory || loading || secondLoading;
  }, [changeCategory, loading, secondLoading]);

  useAutoSetWhatInfo({
    description: t('share_wechat_description'),
    language: setLanguageToFrontend(lang),
    title: `Weee!-${categories.find(item => item.key === productsInfo.search_catalogue_num)?.name}`,
    share_img_url: productsList[0]?.img,
    loading: changeCategory
  });

  useEffect(() => {
    cacheInfoRef.current = {
      ...cacheInfoRef.current,
      productsList,
      mainCategory,
      mainCategoryListArr,
      secondCategory,
      secondCategoryListArr,
      query,
      hasMoreProduct,
      sortArr,
      filterArr,
      totalCount,
      locale,
      vendersList,
      showType
    };
  }, [
    productsList,
    mainCategory,
    mainCategoryListArr,
    secondCategory,
    secondCategoryListArr,
    query,
    hasMoreProduct,
    sortArr,
    filterArr,
    totalCount,
    locale,
    vendersList,
    showType
  ]);
  // window 滚动监听
  const onScroll = event => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    cacheInfoRef.current = {
      ...cacheInfoRef.current,
      yAxis: scrollTop
    };
  };

  useEffect(() => {
    document.addEventListener('scroll', onScroll);

    _gQueryParamsRef.current = {
      zipcode: zipcodeInCookie,
      date: deliveryDateInCookie,
      lang: getLangFromCookie(),
      offset: defaultOffset,
      limit: defaultLimit,
      filter_sub_category: ''
    };

    return () => {
      updateCache(cacheInfoRef.current);
      document.removeEventListener('scroll', onScroll);
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(() => {
    if (isReady && ftuPopupTriggered) {
      ftuRef?.current?.show();
    }
  }, [isReady, ftuPopupTriggered]);

  useEffect(() => {
    const query = qs.parse(window.location.search.slice(1));

    const cacheData = getCache();
    const isCommonZipCode = cacheData?.zipCode === zipcodeInCookie;
    const isCommonDeliveryDate = cacheData?.deliveryDate === deliveryDateInCookie;
    const isCommonCategory =
      cacheData?.query?.filter_sub_category == query?.filter_sub_category && cacheData?.query.slug[0] == filterCategory;
    const isFilterChange = cacheData?.query.filters === query.filters;
    const isChangeLanguage = cacheData?.locale === locale;
    if (isCommonZipCode && isCommonDeliveryDate && isCommonCategory && isFilterChange && isChangeLanguage) {
      initCacheDataForPage(cacheData);
    } else {
      setChangeCategory(false);
      initPageState(categories);
    }
    handleSyncTagInfo(null);
    handleSyncYouMayLike([]);
  }, []);

  useEffect(() => {
    isPlayIdRef.current = '';
    if (!mainCategory) return;
    generatePreNextCategoryItem(mainCategory);
  }, [mainCategory]);

  useEffect(() => {
    if (secondCategoryListArr.length > 0) {
      const second_category = secondCategoryListArr.find(item => item.selected);
      if (second_category) setSecondCategory(second_category);
    }
  }, [JSON.stringify(secondCategoryListArr)]);

  // 通过缓存初始化页面数据
  function initCacheDataForPage(cacheData) {
    setLoading(true);
    const { slug, sort, filters, filter_sub_category } = cacheData.query;

    _gQueryParamsRef.current.filter_sub_category = filter_sub_category || slug[0];
    if (!!sort) {
      _gQueryParamsRef.current.sort = sort;
      setSortRadio(sort);
    }
    if (!!filters) {
      _gFiltersRef.current = _gQueryParamsRef.current.filters = JSON.parse(filters);
      resolveFilter(JSON.parse(filters));
    }
    // if (JSON.stringify(cacheData.query) != JSON.stringify(query)) {
    //   updateQuery();
    // }

    setProductsList(cacheData.productsList);
    setHasMoreProduct(cacheData.hasMoreProduct);
    setTotalCount(cacheData.totalCount);
    setShowType(cacheData.showType);
    cacheData?.sortArr?.map(item => {
      if (item.selected) {
        setSortRadio(item.sort_key);
      }
    });
    clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      window.scrollTo({
        top: cacheData.yAxis,
        behavior: 'smooth'
      });
      setChangeCategory(false);
      setSecondLoading(false);
      setLoading(false);
    }, 400);
  }

  // 通过请求初始化页面数据
  function initPageState(categories) {
    _gQueryParamsRef.current.offset = parseInt(router.query.offset as string) || defaultOffset || 60;
    setHasMoreProduct(productsInfo.filter_total_count > defaultLimit ? true : false);

    const query = qs.parse(window.location.search.slice(1));
    const { sort, filters, filter_sub_category } = query;

    // 不带参数的短链接保护
    if (!_gQueryParamsRef.current?.filter_sub_category) {
      _gQueryParamsRef.current.filter_sub_category = filter_sub_category || filterCategory;
    }

    if (!!sort) {
      _gQueryParamsRef.current.sort = sort;
      setSortRadio(sort);
      let count = filterCount;
      sort && sort != 'recommend' && count++;
      setFilterCount(count);
    }

    if (!!filters) {
      _gFiltersRef.current = _gQueryParamsRef.current.filters = JSON.parse(filters);
      resolveFilter(JSON.parse(filters));
    }
  }

  const filterExplorers = (explorerFilterArr: any[]) => {
    const explorerFilterData = {};
    if (explorerFilterArr.length > 0) {
      explorerFilterArr.forEach(item => {
        const filterOriginData = filterArr?.find(fItem => fItem?.property_key === item.filterKey);
        const _filterValue = item.filterValue || '0'; //兼容 all 的情况
        if (
          filterOriginData &&
          [FilterType.multiple, FilterType.single].includes(filterOriginData.property_show_type) &&
          filterOriginData?.show_out
        ) {
          if (explorerFilterData[item.filterKey]) {
            explorerFilterData[item.filterKey].push({
              value_key: _filterValue,
              value_name: filterOriginData?.property_values?.find(vItem => vItem.value_key === _filterValue)
                ?.value_name,
              property_show_type: filterOriginData?.property_show_type,
              filter_type: filterOriginData?.property_key
            });
          } else {
            explorerFilterData[item.filterKey] = [
              {
                value_key: _filterValue,
                value_name: filterOriginData?.property_values?.find(vItem => vItem.value_key === _filterValue)
                  ?.value_name,
                property_show_type: filterOriginData?.property_show_type,
                filter_type: filterOriginData?.property_key
              }
            ];
          }
        }
      });
    }
    return explorerFilterData;
  };

  const resolveFilter = (_filters: ObjectType) => {
    let _filterCheckBoxArr = [];
    for (let key in _filters) {
      if (key === 'catalogue_num') {
        setSecondCategory({
          catalogue_num: _filters[key],
          catalogue_name: ''
        });
      } else if (_filters[key].toString().includes(',')) {
        const newArr = _filters[key].split(',');
        newArr.map(item => {
          _filterCheckBoxArr = [..._filterCheckBoxArr, { filterKey: key, filterValue: item }];
        });
      } else {
        _filterCheckBoxArr = [..._filterCheckBoxArr, { filterKey: key, filterValue: _filters[key] }];
      }
    }
    if (_filterCheckBoxArr.length > 0) {
      const explorerFilterData = filterExplorers(_filterCheckBoxArr);
      setExplorerFilterData(explorerFilterData);
      setFilterCheckBoxArr(_filterCheckBoxArr);
    }
    let filterCount = _filterCheckBoxArr.length;
    _gQueryParamsRef.current.sort && _gQueryParamsRef.current.sort != 'recommend' && filterCount++;
    setFilterCount(filterCount);
  };

  const updateFilters = (config: ObjectType) => {
    try {
      const { _key, _value, _action } = config;
      if (_action === 'update') {
        _gFiltersRef.current[_key] = _value;
      } else if (_action === 'delete') {
        _gFiltersRef.current[_key] && delete _gFiltersRef.current[_key];
      }
    } catch (e) {
      console.error('updateFilter error: ' + e);
    }
  };

  const updateParams = (config: ObjectType) => {
    try {
      const { _key, _value, _action } = config;
      if (_action === 'update') {
        _gQueryParamsRef.current[_key] = _value;
      } else if (_action === 'delete') {
        _gQueryParamsRef.current[_key] && delete _gQueryParamsRef.current[_key];
      }
      if (JSON.stringify(_gQueryParamsRef.current.filters) === '{}') {
        delete _gQueryParamsRef.current.filters;
      }
    } catch (e) {
      console.error('updateParams error: ' + e);
    }
  };

  const updateQuery = (cateKey?, cateSlug?) => {
    handleSyncTagInfo(null);
    handleSyncYouMayLike([]);
    const newQuery: ObjectType = {};
    const { filter_sub_category, sort, filters } = _gQueryParamsRef.current;
    if (!!filter_sub_category) newQuery.filter_sub_category = filter_sub_category;
    if (!!sort) newQuery.sort = sort;
    if (!!filters) newQuery.filters = JSON.stringify(filters);
    let path = `/mkpl/category/${query.slug[0]}/${query.slug?.[1] || ''}`;
    if (cateKey) {
      path = cateSlug ? `/mkpl/category/${cateKey}/${cateSlug}` : `/mkpl/category/${cateKey}`;
    }
    updateQueryUrl(newQuery, path);
  };

  const fetchProducts = async () => {
    try {
      const reqFilters = _gQueryParamsRef.current.filters && JSON.stringify(_gQueryParamsRef.current.filters);
      const resParams: GetCategoriesResultParams = {
        ..._gQueryParamsRef.current,
        filters: reqFilters
      };
      let filters = [];
      let mainCateKey = defaultFilterCategory;
      const res = await getCategoriesResult(resParams);
      if (res.result && res.object) {
        filters = res.object.filters;
        mainCateKey = res.object?.search_catalogue_num;
        //如果不存在的分类，直接转发到首页
        if (!!res.object?.invalid_catalogue) {
          router.push('/');
          return;
        }
        const type = res?.object?.show_style;
        const sorts = res.object.sorts || [];
        const products = res.object.products || [];
        const filter_total_count = res.object.filter_total_count || 0;
        const second_category_arr = res.object.categories || [];
        const venders = res.object?.venders || [];
        const count =
          type === ShowType.vender
            ? res.object?.venders?.length
            : type === ShowType.group
            ? second_category_arr.length
            : res.object?.products?.length;
        if (resParams.offset === 0) {
          setSortArr(sorts);
          setFilterArr(filters);
          setTotalCount(filter_total_count);
          sorts.map(item => {
            if (item.selected) {
              setSortRadio(item.sort_key);
            }
          });
          setSecondCategoryListArr(second_category_arr);
          setProductsList(products);
        } else {
          setProductsList([...productsList, ...products]);
        }
        setVendersList(venders);
        setShowType(type);
        setHasMoreProduct(count >= defaultLimit);
      }
      setLoading(false);
      setSecondLoading(false);
      setChangeCategory(false);
      return {
        mainCateKey,
        filters
      };
    } catch (error) {
      // TODO need logger
      setChangeCategory(false);
      console.error('category page fetchProducts error: ', error);
    }
  };

  const fetchProductMore = () => {
    if (!loading) {
      const gap = +totalCount - productsList.length;
      if (gap > 0) {
        const _offset = _gQueryParamsRef.current.offset + defaultLimit;
        updateParams({ _key: 'offset', _value: _offset, _action: 'update' });
        fetchProducts();
      } else {
        setHasMoreProduct(false);
      }
    }
  };

  // secondCategory 为ALL时， 页面底部的切换mainCategory --- 构造当前mainCategory的pre & next
  const generatePreNextCategoryItem = item => {
    const index = mainCategoryListArr.findIndex(ele => ele.num == item.key);
    if (index < 0) {
      return;
    }
    const lastIndex = mainCategoryListArr.length - 1;
    if (index === 0) {
      setPreCategoryItem(null);
      setNextCategoryItem(mainCategoryListArr[index + 1]);
    } else if (index === lastIndex) {
      setPreCategoryItem(mainCategoryListArr[index - 1]);
      setNextCategoryItem(null);
    } else {
      setPreCategoryItem(mainCategoryListArr[index - 1]);
      setNextCategoryItem(mainCategoryListArr[index + 1]);
    }
  };

  const handleMainCategory = (item, link?) => {
    const _query = link?.split('?')[1] ?? '';
    const { filters } = qs.parse(_query);
    const _updataFilter = (!!filters && JSON.parse(filters)) || {};
    if (item.key === CategoryKey.bundle) {
      window.location.href = '/bundle_buy';
      return;
    }
    if (item.key === mainCategory.num) return;

    setSortRadio('recommend');
    setChangeCategory(true);
    setMainCategory(item);
    setSecondCategory({
      catalogue_num: '',
      catalogue_name: ''
    });
    updateParams({ _key: 'filter_sub_category', _value: item.key, _action: 'update' });
    updateParams({ _key: 'offset', _value: defaultOffset, _action: 'update' });
    updateFilters({ _key: 'catalogue_num', _action: 'delete' });
    // 切换主分类，重置过滤条件参数
    updateParams({ _key: 'filters', _value: _updataFilter, _action: 'update' });
    updateParams({ _key: 'sort', _value: 'recommend', _action: 'update' });
    fetchProducts().then(res => {
      setChangeCategory(false);
      //点击主要分类之后需要重新计算下过滤的数量
      const _filters = (res && res.filters) || [];
      const newFilters = [];
      const explorerFilters = {};
      _filters.forEach(item => {
        if (item.shareable && item.property_show_type === FilterType.boolean) {
          newFilters.push({ filterKey: item.property_key, filterValue: true, type: FilterType.boolean });
        }
        if (
          item.shareable &&
          (item.property_show_type === FilterType.multiple || item.property_show_type === FilterType.single)
        ) {
          item.property_values.forEach(items => {
            if (item.property_show_type === FilterType.multiple) {
              explorerFilters[item.property_key] = {
                value_key: item.value_key,
                value_name: item.value_name,
                property_show_type: item.property_show_type,
                filter_type: item.property_key
              };
            }
            newFilters.push({
              filterKey: item.property_key,
              filterValue: items.value_key,
              type: item.property_show_type
            });
          });
        }
      });

      const _checkFilter = filterCheckBoxArr.filter(item => {
        return newFilters.findIndex(ele => ele.type === item.type && ele.filterKey === item.filterKey) > -1;
      });
      let count = _checkFilter.length;
      _gQueryParamsRef.current.sort && _gQueryParamsRef.current.sort != 'recommend' && count++;
      setExplorerFilterData({});
      setFilterCheckBoxArr(_checkFilter);
      setFilterCount(count);
    });
    handleSyncTagInfo(null);
    handleSyncYouMayLike([]);
    // updateQuery(item.key);
  };

  const handleSecondCategory = item => {
    const filterObj = query?.filters && JSON.parse(query?.filters);
    if ((!filterObj && !item.catalogue_num) || filterObj?.catalogue_num === item.catalogue_num) {
      return;
    }

    setSecondLoading(true);
    setSecondCategory(item);

    if (item.catalogue_num === '') {
      updateFilters({ _key: 'catalogue_num', _action: 'delete' });
    } else {
      updateFilters({ _key: 'catalogue_num', _value: item.catalogue_num, _action: 'update' });
    }

    !!_gFiltersRef.current?.global && !filterObj?.global && delete _gFiltersRef.current['global'];

    updateParams({ _key: 'filters', _value: _gFiltersRef.current, _action: 'update' });
    updateParams({ _key: 'offset', _value: defaultOffset, _action: 'update' });
    updateParams({ _key: 'filter_sub_category', _value: mainCategory.key, _action: 'update' });
    fetchProducts();
    handleSyncTagInfo(null);
    handleSyncYouMayLike([]);
    // updateQuery(item.catalogue_num, item?.slug);
  };

  const sortFilterApplyCallback = (cacheSort: string, cacheFilterArr: any, filterCount: number) => {
    window.scrollTo(0, 0);
    setFilterCheckBoxArr(cacheFilterArr);
    setFilterCount(filterCount);
    updateParams({ _key: 'offset', _value: defaultOffset, _action: 'update' });
    updateParams({ _key: 'sort', _value: cacheSort, _action: 'update' });
    if (_gFiltersRef.current.catalogue_num) {
      _gFiltersRef.current = { catalogue_num: _gFiltersRef.current.catalogue_num };
    } else {
      _gFiltersRef.current = {};
    }
    const explorerFilterData = filterExplorers(cacheFilterArr);
    setExplorerFilterData(explorerFilterData);
    let newArrMap = {};
    if (cacheFilterArr.length > 0) {
      cacheFilterArr.map(item => {
        if (item.type === FilterType.boolean) {
          updateFilters({ _key: item.filterKey, _value: item.filterValue, _action: 'update' });
        } else {
          newArrMap[item.filterKey] = (newArrMap[item.filterKey] || []).concat(item.filterValue);
          updateFilters({ _key: item.filterKey, _value: newArrMap[item.filterKey]?.toString(), _action: 'update' });
        }
      });
    }
    updateParams({ _key: 'filters', _value: _gFiltersRef.current, _action: 'update' });
    updateParams({ _key: 'filter_sub_category', _value: mainCategory.key, _action: 'update' });
    fetchProducts();
    updateQuery();
  };

  const applyExplorerFilterCallback = (
    cacheSort: string,
    filterData: {
      filter_type: string;
      filter_arr: {
        value_key: string;
        value_name: string;
        property_show_type: string;
        filter_type: string;
      }[];
    }
  ) => {
    //explorer store 筛选项回调
    window.scrollTo(0, 0);
    const filterKeys = filterData.filter_arr?.map(item => item.value_key);
    if (filterKeys?.length) {
      updateFilters({ _key: filterData.filter_type, _value: filterKeys?.toString(), _action: 'update' });
      updateParams({ _key: 'filters', _value: _gFiltersRef.current, _action: 'update' });
    } else {
      updateFilters({ _key: filterData.filter_type, _value: '', _action: 'delete' });
    }
    if (explorerFilterData[filterData.filter_type]) {
      if (!filterKeys?.length) {
        setFilterCount(filterCount - 1);
      }
    } else {
      if (filterKeys?.length) {
        setFilterCount(filterCount + 1);
      }
    }

    const lastExploererFilter = filterCheckBoxArr.filter(item => item.filterKey !== filterData.filter_type);
    filterData.filter_arr.forEach(item => {
      lastExploererFilter.push({
        filterKey: item.filter_type,
        filterValue: item.value_key,
        type: item.property_show_type
      });
    });
    setFilterCheckBoxArr(lastExploererFilter);
    let _explorerFilterData = { ...explorerFilterData };
    if (filterData.filter_arr?.length) {
      _explorerFilterData[filterData.filter_type] = filterData.filter_arr;
    } else {
      if (_explorerFilterData[filterData.filter_type]) {
        delete _explorerFilterData[filterData.filter_type];
      }
    }

    setExplorerFilterData(_explorerFilterData);
    fetchProducts();
    updateQuery();
  };

  const [videoAreaOptions, setVideoAreaOptions] = useState({});
  useEffect(() => {
    let timer = setTimeout(() => {
      let topRect = document.querySelector('div[data-role="second-category"]')?.getBoundingClientRect();
      let bottomRect = document.getElementById('navigation')?.getBoundingClientRect();
      let marginTop = (topRect?.height ?? 0) + (topRect?.top ?? 0);
      setVideoAreaOptions({ rootMargin: `-${marginTop}px 0px -${bottomRect?.height ?? 0}px 0px` });
    });
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const buildPathName = (item, isMainCategory) =>
    `/mkpl/category/${item.key || item.catalogue_num}${item.slug ? `/${item.slug}` : ''}`;

  /** 列表页视频播放（自动播放，手动播放）  */
  let videoTimer = useRef(null);
  let currentVideoInView = useRef(null);
  let playingVideoProps = useRef(null);
  let inViewVideoMap = {};
  const handleInViewChange = props => {
    let { inView, productInfo, mediaItem, play, stop, cardElement /* , trigger */ } = props;
    if (inView) {
      inViewVideoMap[productInfo.id] = props;
    } else {
      delete inViewVideoMap[productInfo.id];
    }

    if (isPlayIdRef.current === '' && inView && mediaItem?.autoplay !== 0) {
      playingVideoProps.current = props;
      currentVideoInView.current = null;
      isPlayIdRef.current = `${productInfo.id}`;
      play?.();
      return;
    }
    if (isPlayIdRef.current === `${productInfo.id}`) {
      currentVideoInView.current = inView;
      if (!inView) {
        clearTimeout(videoTimer.current);
        videoTimer.current = setTimeout(() => {
          if (currentVideoInView.current === false) {
            isPlayIdRef.current = '';
            playingVideoProps.current = null;
            stop?.();
            if (Object.keys(inViewVideoMap).length) {
              for (let key in inViewVideoMap) {
                let rect = inViewVideoMap[key].cardElement.getBoundingClientRect();
                if (rect.top < rect.height || rect.bottom < rect.height) continue; // 跳过大部分内容被遮住的元素
                playingVideoProps.current = props;
                isPlayIdRef.current = `${key}`;
                inViewVideoMap[key].play?.();
                return;
              }
            } else return;
          }
        }, 300);
      }
    }
  };

  const handleBack = () => {
    defaultBack(router);
  };

  const globalNavHeader = useGlobalNavHeader();
  const streamlinedHeader = globalNavHeader?.streamlinedHeader || false;

  return (
    <Layout
      className="pb-0 bg-surface-100-bg"
      seoInfo={seoInfo}
      showTimeBanner={true}
      contentBottomSlot={isRobot && <Footer relatedTopicsData={relatedTopicsData} />}
      header={<CateHeader isHorizontal={false} showBackBtn onBack={handleBack} isMkpl />}>
      <div className="bg-surface-100-bg">
        <HorizontalSlideList
          mainCategory={mainCategory}
          mainCategoryList={mainCategoryListArr}
          secondCategory={secondCategory}
          secondCategoryList={secondCategoryListArr}
          handleMainCategory={handleMainCategory}
          handleSecondCategory={handleSecondCategory}
          showMainCategorySkeleton={true}
          showShadow={true}
          loading={loading}
          changeCategory={changeCategory}
          secondLoading={secondLoading}
          filterCount={filterCount}
          listRef={listRef}
          buildPathName={buildPathName}
          showBadgeOnFilter={true}
          sortFilterProps={{
            sortArr: sortArr,
            filterArr,
            sortRadio,
            filterCheckBoxArr,
            applyCallback: sortFilterApplyCallback,
            explorerFilterData,
            applyExplorerFilterCallback
          }}
          isNeedReplaceUrl
        />
        <RecommendBanner page={'shopping_list'} />
        <div className="w-auto pt-1.5 pb-0 px-2.5" ref={listRef}>
          {!isLoading && (
            <>
              {vendersList?.length > 0 && showType === ShowType.vender ? (
                <VendorCard
                  dataSource={vendersList}
                  queryParams={{
                    filter_sub_category: _gQueryParamsRef?.current?.filter_sub_category,
                    catalogue_num: secondCategory?.catalogue_num,
                    sort: _gQueryParamsRef?.current?.sort,
                    filters: _gQueryParamsRef?.current?.filters
                  }}
                />
              ) : (
                <InfiniteScroll loader={false} hasMore={hasMoreProduct} loadMore={fetchProductMore}>
                  <Masonry
                    breakpointCols={2}
                    className="flex -ml-2.5 w-auto"
                    columnClassName={twMerge('pl-2.5 bg-clip-padding overflow-hidden')}>
                    {productsList?.length > 0 &&
                      productsList.map((item, index) => (
                        <div
                          key={`category-product-item-${_gQueryParamsRef?.current?.filter_sub_category || ''}-${
                            secondCategory?.catalogue_num || ''
                          }-${_gQueryParamsRef?.current?.sort || ''}-${_gQueryParamsRef?.current?.filters || ''}-${
                            item.id
                          }`}
                          id={item.id}
                          className="pb-4">
                          <ProductCard
                            fetchYouMayLike
                            data={item}
                            addCartParams={{
                              referType: 'normal',
                              deliveryDate: getDeliveryDateFromCookie()
                            }}
                            positionInfoT2={{
                              modSecPos: {
                                mod_nm: CategoryMod.itemList,
                                mod_pos: 2
                              },
                              prodPos: index,
                              context: {
                                filter_sub_category: _gQueryParamsRef?.current?.filter_sub_category,
                                catalogue_num: secondCategory?.catalogue_num || 'all',
                                sort: _gQueryParamsRef?.current?.sort || 'recommend',
                                filters: _gQueryParamsRef?.current?.filters
                              }
                            }}
                            showBrandName={true}
                            showAllTags={true}
                            skeletonFactor={isLoading && elementInView(item.id)}
                            skeleton={<Skeleton.Card />}
                            transformLink={() =>
                              `/${lang}/product/${item?.slug ? `${item?.slug}` : `weee/${item?.id}`}?category=${
                                item?.category
                              }`
                            }
                            onViewChange={handleInViewChange}
                            viewOptions={videoAreaOptions}
                          />
                        </div>
                      ))}
                  </Masonry>
                </InfiniteScroll>
              )}
            </>
          )}
          {isLoading && <Skeleton.VerticalMasonryList horizontal={false} />}
        </div>

        {isEmpty && !isLoading && (
          <Empty image={categoryEmptyImg}>
            <h2 className="enki-heading-xl">{t('sf_no_results')}</h2>
            <p className="mt-3 enki-body-base-medium text-surface-100-fg-minor">
              {t('sf_adjust_your_filters_to_see_more')}
            </p>
          </Empty>
        )}

        <ProgressBar height={ymlHeight} />
        <YouMayLike
          type={'vertical'}
          listRef={listRef}
          handleVisChange={height => {
            setYmlHeight(height);
          }}
        />

        {/*
        {guideLayerVisible && !isRobot && !showPopupCreateAccount && (
          <DynamicComponentWithNoSSGuideLayer isHorizontal={false} onDone={() => setGuideLayerVisible(false)} />
        )} */}

        <DynamicCreateAccount ref={ftuRef} organic={organicTriggered} />
        {showCombine && <DynamicCombineFreeShipping />}
      </div>
    </Layout>
  );
}

 const _getServerSideProps: GetServerSideProps = async ctx => {
  const { locale, params, query } = ctx;

  /**
   * TODO
   * 这里可以根据获取到的salesOrganizationId 查询出该销售组织下的基础大类和小类
   * 将基本信息作为props插入页面组件
   */
  let productsInfo: AResponse;
  let seoInfo: AResponse;
  let categories: AResponse;
  let relatedTopicsRes: AResponse;
  const lang = locale === CONSTANT.LANGUAGE_CHINESE_T ? CONSTANT.LANGUAGE_ZHT_ALIAS : locale;
  //一级或二级分类key
  const category = params?.slug?.[0];
  //一级或二级分类slug (一级分类不必须)
  const categorySlug = params?.slug?.[1] || '';
  const { filter_sub_category, sort, filters, limit, offset, slug } = ctx.query;
  const zipCodeInCookie = getValueFromCookie(CONSTANT.ZIP_CODE, ctx);
  const dateInCookie = getValueFromCookie(CONSTANT.DELIVERY_DATE, ctx);
  const salesOrgId = getValueFromCookie(CONSTANT.SALES_ORG_ID, ctx);

  const page_url = !!categorySlug
    ? `/${locale}/category/${category}/${categorySlug}`
    : `/${locale}/category/${category}`;

  try {
    [categories, seoInfo, productsInfo, relatedTopicsRes] = await Promise.all([
      getCategories(
        {
          sales_org_id: salesOrgId
        },
        { ctx }
      ),
      getSeoInfo(
        {
          segment1: 'shopping_list',
          segment2: 'index',
          category_key: category
        },
        { ctx }
      ),
      getCategoriesResult(
        {
          filter_sub_category: (filter_sub_category || category) as string,
          lang: lang || locale,
          zipcode: zipCodeInCookie,
          date: dateInCookie,
          sort: sort as string,
          filters: filters as string,
          limit: (limit || 12) as number,
          offset: (offset || 0) as number
        },
        { ctx }
      ),
      fetchTrendingTopics({ page_url }, ctx)
    ]);
    //如果不存在的分类，直接转发到首页
    if (productsInfo.result && productsInfo.object?.invalid_catalogue) {
      return {
        redirect: {
          destination: `${process.env.NEXT_PUBLIC_WEB_HOST}/${locale}`,
          permanent: false
        }
      };
    }

    const exp692 = await doGoogleOneTapExperiment(query, ctx);
    let organicTriggered = getOrganicTriggered({ lang, isLogin: getLoginState(ctx), query, ctx, exp692 });
    const relatedTopicsData = relatedTopicsRes.object?.contents || [];

    return {
      props: {
        productsInfo: productsInfo?.object || {},
        path: `/${locale}/mkpl/category/${category}/${categorySlug}`,
        seoInfo: seoInfo?.object?.seo_info ?? null,
        showSearchAction: true,
        categories: categories?.object?.category_list || [],
        isRobot: isRobot(ctx),
        isLogin: getLoginState(ctx),
        ftuPopupTriggered:
          couldShowFtuPopup({ lang, isLogin: getLoginState(ctx), query, ctx, exp692 }) || organicTriggered,
        organicTriggered,
        relatedTopicsData,
        ...getAssetsCdnConfig(ctx),
        ...getHttpReqAwareProps(ctx)
      }
    };
  } catch (error) {
    logger.error({
      method: 'pdp error',
      error: error
    });
    return {
      props: {}
    };
  }
};

export default withPageDataCache(Category, 'sessionStorage', 'cache-category-list');


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/mkpl/category/[...slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  